import {ApplicationConfig, inject, PLATFORM_ID, provideAppInitializer, provideBrowserGlobalErrorListeners, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {TranslocoHttpLoader} from './transloco-loader';
import {AvailableLangs, provideTransloco, TranslocoService} from '@jsverse/transloco';
import {environment} from '../environments/environment';
import {isPlatformBrowser, registerLocaleData} from '@angular/common';
import {clientIdInterceptor} from './core/interceptors/client-id.interceptor';
import {accessTokenInterceptor} from './core/interceptors/access-token.interceptor';
import {httpErrorInterceptor} from './core/interceptors/http-error-interceptor';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';

function initTranslocoLang() {
  const transloco = inject(TranslocoService);
  const platformId = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);

  const available = (transloco.getAvailableLangs() as AvailableLangs)
    .map(l => typeof l === 'string' ? l : l.id);

  const browserLangs = isBrowser
    ? (globalThis.navigator?.languages ?? [globalThis.navigator?.language].filter(Boolean) as string[])
    : [];

  const match = browserLangs
    .map(code => code?.split?.('-')[0]?.toLowerCase())
    .find(lang => !!lang && available.includes(lang!));

  transloco.setActiveLang(match ?? transloco.getDefaultLang());
}

registerLocaleData(localeDe);
registerLocaleData(localeEn);
registerLocaleData(localeFr);
registerLocaleData(localeIt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideHttpClient(withInterceptors([clientIdInterceptor, accessTokenInterceptor, httpErrorInterceptor])),
    provideTransloco({
      config: {
        availableLangs: ['en', 'de', 'fr', 'it'],
        defaultLang: 'en',
        fallbackLang: 'en',
        reRenderOnLangChange: false,
        prodMode: environment.production,
      },
      loader: TranslocoHttpLoader
    }),
    provideAppInitializer(() => initTranslocoLang()),
  ]
};
